export default __webpack_public_path__ + "static/meducation-medcheck-8aed8e7ec62ad6b1c9a169d0947d12c6.mp4";